<template>
  <div id="app">
    <div class="section section-hero">
      <div class="container">
        <navigation></navigation>
        <transition :name="transitionName" mode="out-in">
          <router-view :key="'a' + $route.path"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './components/Navigation'

export default {
  name: 'app',
  components: {
    navigation: navigation
  },
  data() {
    return {
      transitionName: 'fadel'
    }
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      const toDepth = parseInt(to.path.substring(1))
      const fromDepth = parseInt(from.path.substring(1))
      this.transitionName = toDepth < fromDepth ? 'fader' : 'fadel'
      next()
    })
  }
}
</script>

<style lang="scss">
body,
.fader-enter-active,
.fader-leave-active,
.fadel-enter-active,
.fadel-leave-active {
  transition: all 0.25s ease;
}

.fadel-enter,
.fader-leave-active {
  opacity: 0;
  -webkit-transform: translate(10vw, 0);
  transform: translate(10vw, 0);
}
.fadel-leave-active,
.fader-enter {
  opacity: 0;
  -webkit-transform: translate(-10vw, 0);
  transform: translate(-10vw, 0);
}

@media (max-width: 39.9375em) {
  .calcnav .calcnav__btn.isActive {
    background-color: #083650;
    border-color: #083650;
    &:hover {
      background-color: #ef5050;
      border-color: #ef5050;
    }
  }
}
.bg-secondary {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue